module.exports = __webpack_public_path__ + "img/roadmap-bg-3.82e22303.webp";